import script from "./HandlebarSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./HandlebarSelection.vue?vue&type=script&setup=true&lang=ts"

import "./HandlebarSelection.vue?vue&type=style&index=0&id=5bc9662c&lang=scss"

const __exports__ = script;

export default __exports__